export default __webpack_public_path__ + "static/media/community4.53b68bef.svg";